import React, { useContext, useState, useEffect } from "react";
import { MobileOtpContext } from "../MobileOtpView";
import Button from "../../../../components/ButtonComponent/Button";
import OtpInput from "react18-input-otp";
import Arrow from "../../../../assests/images/backArrow.svg";
import AlertBox from "../../../../components/alertComponent/AlertBox";
import "./MobileEnterOtp.css";
import Spinner from "../../../../components/spinner/Spinner";
import Logo from "../../../../assests/images/vguard_logo.png";

const EnterMobileOtp = ({ textContents }) => {
  const {
    otp,
    handleOTPChange,
    showAlert,
    setShowAlert,
    alertMessage,
    onSubmitOTP,
    showGetOtp,
    handleGetOTP,
    timer,
    showResend,
    handleResendOTP,
    successOTPMessage,
    otpStatusCode,
    isOtpValid,
    setOtp
  } = useContext(MobileOtpContext);

  return (
    <>
      <div className="loginContainer">
        <div className="col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12 mainBoxEnterOtp">
          <div className="logoSection">
            <img src={Logo} alt="logo" />
          </div>
          {otpStatusCode == 200 ? (
            <div>
              <div className="otpMessageHd">
                {textContents?.verifySixMobileMessage}
              </div>
              <p className="otpSubMsg">{successOTPMessage}</p>
            </div>
          ) : (
            <div>
              <div className="otpMessageHd">
                {textContents.verifyMobileMessage}
              </div>
              <p className="otpSubMsg">{textContents?.mobileOtpMessage}</p>
            </div>
          )}

          <form className="form-otp">
            <div className="otp-mob-div">
              <OtpInput
                value={otp}
                onChange={handleOTPChange}
                numInputs={6}
                autoComplete="off"
                isInputNum={true}
              />
            </div>
            <p className="mt-3 ">
              <span className="textLight dntReceiveCode">
                {showResend && textContents.didntRecieveTheCode}
              </span>
              <span>
                {showGetOtp && (
                  <span className="resendOtpNew" onClick={handleGetOTP}>
                    {textContents.getOTP}
                  </span>
                )}
                {timer > 0 && (
                  <span className="resendOtpNew"> {timer} sec</span>
                )}
                {showResend && (
                  <span className="resendOtpNew" onClick={handleResendOTP}>
                    {textContents.resend}
                  </span>
                )}
              </span>
            </p>
          </form>
          <div className="buttonContainerOtp">
            <Button
              text={textContents.submit}
              onClick={() => onSubmitOTP()}
              disable={!isOtpValid}
            ></Button>
          </div>
        </div>
      </div>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        title={textContents.alert}
        alertMessage={alertMessage}
        okFunction={()=>setOtp("")}
      />
    </>
  );
};

export default EnterMobileOtp;
